import {RequestStatus} from "../../../request";
import {CohortReport} from "./reducer";

export const FetchCohortEventsReport = (from: Date, until: Date, isUnique:boolean,filter: { campaignId: string | null }) => {
    return {
        type: 'events-request-report',
        from: from,
        until: until,
        isUnique: isUnique,
        filter: filter,
    }
}

export const UpdateReportRequestState = (requestState: RequestStatus) => {
    return {
        type: 'events-update-request-state',
        requestState: requestState
    }
}

export const UpdateEventsCohortReport = (report: CohortReport) => {
    return {
        type: 'events-update-report',
        report: report
    }
}
